// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"025b2f7c","686":"5c378f66","704":"567f78b7","778":"800cfa02"}[chunkId] + ".chunk.js";
};